import React from 'react';
import { Control, Link } from "MWComponents";
import Calculator from '../../../auxiliary-components/Calculator';
import "../less/main.less"
import { Preloader } from 'MWC';
import clearBR from "../../../helpers/utils/clearBR";
import Hint from "../views/hint.c";
import TextAboveFooter from "../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c";
import FilesForDownload from '../../../auxiliary-components/shared/FilesForDownload/views/file.c';

export default function template() {
    const model = this.getModel(),
        isMobile = this.isViewportMobile(),
        creditDescriptionOne = isMobile ?
            clearBR(this.l10n("CREDIT_INSTANT_INSTALLMENT_DESC_1")) :
            this.l10n("CREDIT_INSTANT_INSTALLMENT_DESC_1"),
        creditDescriptionTwo = isMobile ?
            clearBR(this.l10n("CREDIT_INSTANT_INSTALLMENT_DESC_2")) :
            this.l10n("CREDIT_INSTANT_INSTALLMENT_DESC_2");

    return !model.creditSum ?
        (<div className="preload-wrapper">
            <Preloader />
        </div>)
        :
        (<div className="credit-calculator instant-installment">

            <div className="banner">
                <div className="banner-content">
                    <h1 className="banner-title">{this.l10n('CREDIT_INSTANT_INSTALLMENT_BANNER_TITLE')}</h1>
                    <div className="banner-message">{this.l10n('CREDIT_INSTANT_INSTALLMENT_BANNER_MESSAGE')}</div>
                    <Link href={`/credit`} onClick={e => this.context.app.navigate(`/credit`, e)}>
                        <div className="backward-btn">{this.l10n('CREDIT_NEW_INSTALLMENT_BANNER_BACKWARD')}</div>
                    </Link>
                </div>
            </div>
            <div className="content">
                <div className="credit-description">
                    <h2 className="credit-description-title block-title">{this.l10n('CREDIT_INSTANT_INSTALLMENT_WHAT_IS')}</h2>
                    <p className="credit-description-item" dangerouslySetInnerHTML={{ __html: this.l10n(creditDescriptionOne) }} />
                    <p className="credit-description-item" dangerouslySetInnerHTML={{ __html: this.l10n(creditDescriptionTwo) }} />
                </div>

                <div className="credit-offer instant-installment-offer">
                    <h2 className="block-title">{this.l10n('CREDIT_INSTANT_INSTALLMENT_OFFER')}</h2>
                    <div className="credit-offer-body">
                        <div className="credit-offer-body-item">
                            <p className="item-title block-title">
                                {this.l10n('CREDIT_INSTANT_INSTALLMENT_OFFER_1_TITLE')}
                                <span className="upper">{this.l10n('CREDIT_INSTANT_INSTALLMENT_UAH')}</span>
                            </p>
                            <p className="item-description">
                                {this.l10n('CREDIT_INSTANT_INSTALLMENT_OFFER_1_TEXT')}
                            </p>
                        </div>
                        <div className="credit-offer-body-item">
                            <p className="item-title block-title">
                                {this.l10n('CREDIT_INSTANT_INSTALLMENT_OFFER_2_TITLE')}
                                <span className="upper">{this.l10n('CREDIT_INSTANT_INSTALLMENT_MONTHS')}</span>
                            </p>
                            <p className="item-description">
                                {this.l10n('CREDIT_INSTANT_INSTALLMENT_OFFER_2_TEXT')}
                            </p>
                        </div>
                        <div className="credit-offer-body-item">
                            <p className="item-title block-title">
                                {this.l10n('CREDIT_INSTANT_INSTALLMENT_OFFER_3_TITLE')}
                            </p>
                            <p className="item-description">
                                {this.l10n('CREDIT_INSTANT_INSTALLMENT_OFFER_3_TEXT')}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="credit-calculator">
                    <h2 className="block-title">{this.l10n('CREDIT_INSTANT_INSTALLMENT_CALC')}</h2>
                    <div className="calculator-wrapper">
                        <Calculator model={this.getModel()} type={this.state.selectedType} {...this.props} />
                    </div>
                </div>

                <div className="credit-payment">
                    <h2 className="block-title">{this.l10n('CREDIT_INSTANT_INSTALLMENT_PAYMENT_TITLE')}</h2>
                    <div className="credit-payment-body">
                        <div className="credit-payment-body-item">
                            <div className="item-img cards"></div>
                            <div className="item-text">{this.l10n('CREDIT_INSTANT_INSTALLMENT_PAYMENT_STEP_1')}</div>
                        </div>
                        <div className="credit-payment-body-item">
                            <div className="item-img phone"></div>
                            <div className="item-text">{this.l10n('CREDIT_INSTANT_INSTALLMENT_PAYMENT_STEP_2')}</div>
                        </div>
                        <div className="credit-payment-body-item">
                            <div className="item-img sector"></div>
                            <div className="item-text">{this.l10n('CREDIT_INSTANT_INSTALLMENT_PAYMENT_STEP_3')}</div>
                        </div>
                    </div>
                </div>

                <div className="credit-instruction">
                    <h2 className="block-title">{this.l10n('CREDIT_INSTANT_INSTALLMENT_INSTRUCTION_TITLE')}</h2>
                    <div className="credit-instruction-body">
                        <div className="line" />
                        <div className="credit-instruction-body-item">
                            <div className="item-figure one"></div>
                            <p className="item-title">{this.l10n('CREDIT_INSTANT_INSTALLMENT_INSTRUCTION_ITEM_1_TITLE')}</p>
                            <p className="item-description">{this.l10n('CREDIT_INSTANT_INSTALLMENT_INSTRUCTION_ITEM_1_TEXT')}</p>
                            <div className="dot" />
                            <div className="bullet" />
                        </div>
                        <div className="credit-instruction-body-item">
                            <div className="item-figure two"></div>
                            <p className="item-title">{this.l10n('CREDIT_INSTANT_INSTALLMENT_INSTRUCTION_ITEM_2_TITLE')}</p>
                            <p className="item-description">{this.l10n('CREDIT_INSTANT_INSTALLMENT_INSTRUCTION_ITEM_2_TEXT')}</p>
                            <div className="dot" />
                            <div className="bullet" />
                        </div>
                        <div className="credit-instruction-body-item">
                            <div className="item-figure three"></div>
                            <p className="item-title">{this.l10n('CREDIT_INSTANT_INSTALLMENT_INSTRUCTION_ITEM_3_TITLE')}</p>
                            <div className="item-description">{this.l10n('CREDIT_INSTANT_INSTALLMENT_INSTRUCTION_ITEM_3_TEXT')}
                                <Hint {...this.props}>
                                    <span>{this.l10n('CREDIT_INSTANT_INSTALLMENT_INSTRUCTION_HINT')}</span>
                                </Hint>
                            </div>
                            <div className="dot" />
                            <div className="bullet" />
                        </div>
                    </div>
                </div>

                <div className="credit-close">
                    <h2 className="block-title">{this.l10n('CREDIT_NEW_INSTALLMENT_CLOSE_TITLE')}</h2>
                    <ul className="close-list">
                        <p className="close-list-title">{this.l10n('CREDIT_NEW_INSTALLMENT_CLOSE_TEXT')}</p>
                        <li className="close-list-item">
                            {this.l10n("CREDIT_NEW_INSTALLMENT_CLOSE_ITEM_1")}
                        </li>
                        <li className="close-list-item">
                            {this.l10n("CREDIT_NEW_INSTALLMENT_CLOSE_ITEM_2")}
                        </li>
                    </ul>
                </div>

                <FilesForDownload
                  page={'white-page'}
                  style={{marginBottom: 0}}
                  lang={this.props.lang}
                  widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
                />

                <div className='disclaimer-wrapper' style={{marginTop: 0}}>
                    <TextAboveFooter widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}></TextAboveFooter>
                </div>
            </div>
        </div>);
}
